interface ExportConfirmationContent {
  title: string;
  cancel: string;
  export: string;
}

interface GroupLeaderFilterContent {
  label: string;
  placeholder: string;
  allOption: string;
  emptyState: string;
  errorTooltip: string;
  otherSectionLabel: string;
}

interface SortModalContent {
  title: string;
  textAscending: string;
  textDescending: string;
  numericAscending: string;
  numericDescending: string;
  applyButton: string;
  cancelButton: string;
  closeAriaLabel: string;
}

export interface ActionReportsContent {
  pageTitle: string;
  viewReport: string;
  selectActionReport: string;
  birthdaysArTitle: string;
  birthdaysArDescription: string;
  whosNewTitle: string;
  whosNewDescription: string;
  whosNewWithCustomersTitle: string;
  whosNewWithCustomersDescription: string;
  whosCloseTitle: string;
  renewalsArTitle: string;
  renewalsArDescription: string;
  cbrArTitle: string;
  cbrArDescription: string;
  cvrArTitle: string;
  cvrArDescription: string;
  nonBonusableBvArTitle: string;
  nonBonusableBvArDescription: string;
  provisionalArTitle: string;
  provisionalArDescription: string;
  onlineStatementsTitle: string;
  onlineStatementsDescription: string;
  aboNameNumber: string;
  nameNumber: string;
  watchlist: string;
  provisionalTag: string;
  fcyTag: string;
  sopUpForRenewalTag: string;
  international: string;
  exportButton: string;
  exportError: string;
  exportConfirmation: ExportConfirmationContent;
  applicantName: string;
  searchPlaceholder: string;
  clearSearch: string;
  bookmarkAction: string;
  phoneAction: string;
  messageAction: string;
  whatsAppAction: string;
  aboTypeLabel: string;
  customerTypeLabel: string;
  filter: {
    groupLeader: GroupLeaderFilterContent;
  };
  aboTag: string;
  memberTag: string;
  customerTag: string;
  guestCustomerTag: string;
  ssiUplineReportTitle: string;
  bronzeGroupTrackingTitle: string;
  saqActionReportTitle: string;
  fsiActionReportTitle: string;
  migratedTag: string;
  rankBadge: string;
  sortButtonAriaLabel: string;
  sortModal: SortModalContent;
  tableColumnLoadingLabel: string;
}

const content: ActionReportsContent = {
  pageTitle: "Action Reports",
  viewReport: "View Report",
  selectActionReport: "Select an Action Report",
  birthdaysArTitle: "Birthdays",
  birthdaysArDescription: "ABOs who have a birthday this month",
  whosNewTitle: "Who's New",
  whosNewDescription: "New ABOs this month",
  whosNewWithCustomersTitle: "New ABO/PC Activity",
  whosNewWithCustomersDescription:
    "This report shows a list of new ABOs, ABOs who have rejoined the business, ABOs who have transitioned from customers, and all new customers in your group over the last 12 rolling months. Congratulations on your business growth!",
  whosCloseTitle: "Who's Close",
  renewalsArTitle: "Renewals",
  renewalsArDescription: "ABOs that are eligible to renew within 100 days",
  cbrArTitle: "CBR Clock",
  cbrArDescription: "IBOs whose CBR Clock has started",
  cvrArTitle: "CVR Compliance",
  cvrArDescription: "IBOs who are not CVR compliant",
  nonBonusableBvArTitle: "Non-Bonusable BV",
  nonBonusableBvArDescription: "Current list of IBOs who are below 60% VCS and generating Non-Bonusable BV",
  provisionalArTitle: "IBO Onboarding",
  provisionalArDescription: "IBOs in progress towards sponsoring eligibility",
  onlineStatementsTitle: "Online Statements",
  onlineStatementsDescription: "Access and download PDF business statements for the past three fiscal years",
  aboNameNumber: "ABO Name / Number",
  applicantName: "Applicant Name / Number",
  nameNumber: "Name / Number",
  watchlist: "Watchlist",
  provisionalTag: "PABO",
  fcyTag: "FCY",
  sopUpForRenewalTag: "SOP up for Renewal",
  international: "International",
  exportButton: "Export",
  exportError: "Export failed. Please try again.",
  exportConfirmation: {
    title: "Export Report",
    cancel: "Cancel",
    export: "Export",
  },
  searchPlaceholder: "Search",
  clearSearch: "Clear Search",
  bookmarkAction: "Bookmark",
  phoneAction: "Phone",
  messageAction: "Message",
  whatsAppAction: "Send WhatsApp message",
  aboTypeLabel: "ABO",
  customerTypeLabel: "Customer",
  filter: {
    groupLeader: {
      label: "Select Group Leader",
      placeholder: "Search by name or ABO number",
      allOption: "All New ABOs / PCs",
      emptyState: "No ABOs match this Group Leader's subtree",
      errorTooltip: "Group Leader tree could not be loaded",
      otherSectionLabel: "Other",
    },
  },
  aboTag: "ABO",
  memberTag: "Member",
  customerTag: "Customer",
  guestCustomerTag: "Guest Customer",
  ssiUplineReportTitle: "Strong Start Incentive+ Upline Report",
  bronzeGroupTrackingTitle: "Bronze Group Tracking",
  saqActionReportTitle: "Sponsoring Activity Qualification (SAQ)",
  fsiActionReportTitle: "Founders Sales Incentive{symbol} Report",
  migratedTag: "Migrated",
  rankBadge: "Rank {rank}",
  sortButtonAriaLabel: "Sort",
  sortModal: {
    title: "Sort By",
    textAscending: "{column} A-Z",
    textDescending: "{column} Z-A",
    numericAscending: "{column} (Low to High)",
    numericDescending: "{column} (High to Low)",
    applyButton: "Apply",
    cancelButton: "Cancel",
    closeAriaLabel: "Close sort options",
  },
  tableColumnLoadingLabel: "Loading column header",
};

export default content;
